import clsx from "clsx";
import Link from "next/link";
import React, { FC, HTMLAttributes } from "react";

export type IConsentMessageProps = HTMLAttributes<HTMLParagraphElement> & {};

const ConsentMessage: FC<IConsentMessageProps> = (props) => {
  const { className, ...other } = props;
  return (
    <p className={clsx("", className)} {...other}>
      By clicking the subscribe button, you are agreeing to the Certbar{" "}
      <Link
        href="/terms-of-use"
        target="_blank"
        className="text-secondary-900 underline"
      >
        Terms of Use
      </Link>{" "}
      and{" "}
      <Link
        href="/privacy-policy"
        target="_blank"
        className="text-secondary-900 underline"
      >
        Privacy Policy
      </Link>
      .
    </p>
  );
};

export default ConsentMessage;
